/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DailyMenu } from '../models/DailyMenu';
import type { MealOrderRequest } from '../models/MealOrderRequest';
import type { Offer } from '../models/Offer';
import type { WeeklyMenu } from '../models/WeeklyMenu';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class MealsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * API endpoint that returns the daily menu with meal options.
     * @returns DailyMenu
     * @throws ApiError
     */
    public mealsRetrieve({
        date,
    }: {
        date: string,
    }): CancelablePromise<DailyMenu> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/meals/{date}/',
            path: {
                'date': date,
            },
        });
    }

    /**
     * API endpoint that returns the meal offers for a given date and meal type.
     * @returns Offer
     * @throws ApiError
     */
    public mealsOfferRetrieve({
        date,
        mealName,
    }: {
        date: string,
        mealName: string,
    }): CancelablePromise<Offer> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/meals/{date}/{meal_name}/offer/',
            path: {
                'date': date,
                'meal_name': mealName,
            },
        });
    }

    /**
     * API endpoint for placing meal orders.
     * Endpoint: PUT /api/meals/{date}/{meal_name}/order/
     * where:
     * - date is in YYYY-MM-DD format
     * - meal_name is one of: breakfast, lunch, dinner
     * @returns MealOrderRequest
     * @throws ApiError
     */
    public mealsOrderUpdate({
        date,
        mealName,
        requestBody,
    }: {
        date: string,
        mealName: string,
        requestBody?: MealOrderRequest,
    }): CancelablePromise<MealOrderRequest> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/meals/{date}/{meal_name}/order/',
            path: {
                'date': date,
                'meal_name': mealName,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Return meal-ordering overview for a calendar week.
     *
     * Synchronizes local `MealOrder` objects with the external Logimen data in a
     * single DB transaction, then composes the weekly payload.
     * @returns WeeklyMenu
     * @throws ApiError
     */
    public mealsWeeklyRetrieve({
        startDate,
    }: {
        /**
         * Date (YYYY-MM-DD) of any day in the requested week.
         */
        startDate?: string,
    }): CancelablePromise<WeeklyMenu> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/meals/weekly/',
            query: {
                'start_date': startDate,
            },
        });
    }

}
